import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { observer } from 'mobx-react';

import { Loader } from 'src/components/Loader';
import { useStore } from 'src/modules/users/hooks/useStore';

import { StoreContext } from '../store';

export const PaymentMethodView = observer(() => {
  const store = useStore(StoreContext);

  return (
    <Modal className="modal-slide" show={store.viewModalOpen} onHide={store.closeCardInfoModal}>
      <Modal.Header closeButton>
        <Modal.Title as="h5">Данные карты</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {store.methodDetailsLoading ? (
          <Loader />
        ) : (
          <>
            <div className="mb-3">
              <div className="font-regular-sm text-muted">4 последние цифры</div>
              <div className="font-regular-base">{store.chosenCard?.cardNumber}</div>
            </div>
            <div className="mb-3">
              <div className="font-regular-sm text-muted">Месяц / год</div>
              <div className="font-regular-base">{store.chosenCard?.expirationDate}</div>
            </div>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={store.closeCardInfoModal}>
          Закрыть
        </Button>
      </Modal.Footer>
    </Modal>
  );
});
